<template>
  <div class="form-family-sick" v-if="project != null">
    <table class="table" v-if="project.family_interviews.length > 0">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th width="40%" scope="col">¿Cuál es su concepto de la dinámica familiar y de la influencia del teletrabajo?</th>
          <th scope="col">Editar</th>
          <th scope="col">Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="family_interview in project.family_interviews" :key="family_interview.id">
          <td>{{family_interview.name}}</td>
          <td>{{family_interview.question}}</td>
          <td><b-button variant="primary" @click.prevent="editfamilyInterview(family_interview)">Editar</b-button></td>
          <td><b-button variant="danger" @click.prevent="deleteFamilyInterview(family_interview.id)">Eliminar</b-button></td>
        </tr>
      </tbody>
    </table>                  
    <h1>Entrevista a integrantes de la familia</h1>
    <table class="table" >
      <thead>
      </thead>
      <tbody>
        <tr>
          <td>Nombre</td>
          <td>
            <input type="text" class="form-control" id="name" placeholder="Nombre" v-model="familyInterview.name">
          </td>
        </tr>
        <tr>
          <td width="40%">¿Cuál es su concepto de la dinámica familiar y de la influencia del teletrabajo?</td>
          <td>
            <input type="text" class="form-control" id="age" placeholder="Descripción" v-model="familyInterview.question">
          </td>          
        </tr>
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="create" v-if="mode == 'create'">Guardar</b-button>
    <b-button variant="primary" @click.prevent="update" v-if="mode == 'update'">Editar</b-button>
    <b-button variant="success" @click.prevent="clear">limpiar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'FormfamilyInterview',
  props: ['project_id', 'assignment_id'],
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
      typeMessage: '',
      familyInterview: { id: null},
      mode: 'create'
    }
  },
  components: {
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    maskName(attribute, value, itemSearch){
      if (value != null && value != "") {
        return this.selects[attribute].filter(obj => obj[itemSearch] == value)[0].name
      }else{
        return 'N/A'
      }      
    },
    clear(){
      this.familyInterview = { id: null}
      this.mode = 'create'
    },
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
			axios.get(`/information_work.json?project_id=${this.projectId}&assignment_id=${this.assignmentId}`).then(res=>{
				if(res.status == 200){
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    editfamilyInterview(family_interview){
      this.familyInterview = family_interview
      this.mode = 'update'
    },
    create(){
      this.defaultAxios()
      delete this.familyInterview.id
			axios.post(`/workflow/family_interviews`, { id: this.projectId, family_interview: this.familyInterview }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Guardado', 'alert-success')
          this.clear()
				}else{
          this.showMessage('No se pudo guardar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('No se pudo guardar', 'alert-danger')
      })
    },
    update(){
      this.defaultAxios()
			axios.put(`/workflow/family_interviews/${this.familyInterview.id}`, { family_interview: this.familyInterview }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Registro actualizado', 'alert-success')
          this.clear()
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },    
    deleteFamilyInterview(id){
      this.defaultAxios()
			axios.delete(`/workflow/family_interviews/${id}`, {}).then(res=>{
        this.getInformationWork()
				if(res.status == 200){          
          this.showMessage('Familiar eliminado', 'alert-success')
				}else{
          this.showMessage('No se pudo eliminar el familiar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('No se pudo eliminar el familiar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {

  },
  watch: {

  },
  filters: {

  }
}
</script>

<style scoped>

</style>